import ahoy from 'ahoy.js'
import Conversion from './conversion'
import { productionEnv } from 'lib/env'

ahoy.debug(!productionEnv)
ahoy.configure({
  visitsUrl: '/a/visits',
  eventsUrl: '/a/events',
  startOnReady: false,
})

export default class Ahoy extends Conversion {
  constructor ({ ...args } = {}) {
    super(args)
    this.pushWithoutInstall = false
    this.pushWithoutConsent = false
  }

  install () {
    ahoy.start()
  }

  handleConsentGiven () {
    ahoy.trackView() // this tracks page view
  }

  deliver (item) {
    ahoy.track(item[0], item[1])
  }

  // Override doe to view_item event containing multiple items but server expects one item per event
  static formatItems (...items) { return items.flatMap(item => this.formatItem(item)).filter(item => !!item) }

  static formatItem ({ event, ...rest }) {
    switch (event) {
      case 'view_item':
        return this.#formatViewItem(rest)
      // currently this is natively done in this.handleConsentGiven()
      // case 'page_view':
      //   return (['$view', rest])
      default:
        return null
    }
  }

  static #formatViewItem ({ items }) {
    return items.map(item => ['$subject_view', { subject_id: item.item_id, subject_type: 'Room' }])
  }

  static _log_name = 'ANLT Ahoy'
}
